module.exports = __webpack_public_path__ + "4e5ba5130241adefc5831f448ee94c4a.MP3";